import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import ActionChip from '@/features/compose/components/ActionChip';
import type { Action } from '@/types/actions';

type Props = {
  actions: Action[];
};

export default function ActionChipList({ actions }: Props) {
  const { i18n } = useTranslation();

  const titleParts = new Intl.ListFormat(i18n.language, {
    type: 'conjunction',
  }).formatToParts(actions.map((action) => action.title));

  const parts: ReactNode[] = [];
  let chipIndex = 0;

  for (const part of titleParts) {
    if (part.type === 'literal') {
      parts.push(part.value);
      continue;
    }

    const action = actions[chipIndex];
    chipIndex += 1;

    if (!action) continue;

    parts.push(
      <ActionChip
        key={action.id}
        title={action.title}
        source={action.source}
      />,
    );
  }

  return parts;
}
